import { Text, Image } from '@chakra-ui/react'
import Brand from '../../Assets/Logo/logo.svg'

export function Logo () {
  return <Image src={Brand} />
}
